if (!customElements.get('shoppable-layout-slider')) {
  class ShoppableLayoutSlider extends HTMLElement {
    constructor() {
      super();
      this.style.opacity = '0';
      this.style.transition = 'opacity 0.3s ease-out';

      // sync 예약 타이머 핸들
      this._syncTimer = null;

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.observeSection.bind(this));
      }
      this.observeSection();
    }

    observeSection() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this);
    }

    init() {
      if (this.swiper) return;

      const swiperContainer = this.querySelector('.swiper-shoppable-slider');
      const isInsideContainerSlider = this.closest('.shoppable-container__slider');
      if (!swiperContainer) return;

      this.swiper = new Swiper(swiperContainer, {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },

        spaceBetween: 1,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,

        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: isInsideContainerSlider ? 40 : 2,
            slidesPerView: 5.5
          },
          990: {
            spaceBetween: isInsideContainerSlider ? 32 : 2,
            slidesPerView: 4.5
          },
          750: {
            spaceBetween: isInsideContainerSlider ? 24 : 2,
            slidesPerView: 2.5
          },
          360: {
            spaceBetween: isInsideContainerSlider ? 16 : 2,
            slidesPerView: 1.5
          }
        },

        on: {
          init: (swiper) => {
            this.style.opacity = '1';
            this.scheduleSync(swiper, true);
          },

          // autoplay/interaction 중 클래스/DOM 확정 타이밍이 애매해서 둘 다 걸어 안정화
          slideChange: (swiper) => {
            this.scheduleSync(swiper, false);
          },
          slideChangeTransitionEnd: (swiper) => {
            this.scheduleSync(swiper, false);
          }
        }
      });
    }

    /**
     * ✅ DOM/active class 확정 이후에 실행되도록 "스케줄링" (레이스 방지)
     * - autoplay로 빠르게 전환될 때, 특정 슬라이드(특히 loop clone)에서 active video 선택이 null이 되는 케이스 방지
     */
    scheduleSync(swiper, isInit) {
      if (this._syncTimer) {
        clearTimeout(this._syncTimer);
        this._syncTimer = null;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this._syncTimer = setTimeout(() => {
            this.syncActiveVideo(swiper, isInit);
          }, 30);
        });
      });
    }

    /**
     * active slide의 video만 재생
     * - muted/autoplay는 브라우저 정책 + loop clone + 비동기 때문에 "property + defaultMuted"까지 같이 강제하는 게 안정적
     */
    syncActiveVideo(swiper, isInit) {
      const root = this;
      const videos = root.querySelectorAll('video');
      if (!videos.length) return;

      // ✅ loop clone 포함해서 "현재 활성 슬라이드 DOM"을 swiper.activeIndex로 확정
      const activeSlideEl = swiper?.slides?.[swiper.activeIndex] || root.querySelector('.swiper-slide-active');
      const activeVideo = activeSlideEl ? activeSlideEl.querySelector('video') : null;

      videos.forEach((video) => {
        // 공통 속성
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        if (isInit) {
          try { video.pause(); } catch (e) {}
        }

        const isActive = activeVideo && video === activeVideo;

        if (isActive) {
          // ✅ autoplay 정책 대응: muted를 가장 먼저, 그리고 defaultMuted까지 강제
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');

          // autoplay 속성은 정책상 크게 의미 없지만(대부분 muted가 핵심), 상태 일관성 위해 맞춤
          video.autoplay = true;
          video.setAttribute('autoplay', '');

          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        } else {
          try { video.pause(); } catch (e) {}

          // 비활성: 재생은 끄되, muted를 굳이 false로 돌리면 레이스로 다시 흔들릴 수 있음
          // "비활성은 무조건 unmute"가 꼭 필요하면 아래 2줄을 살려라.
          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');

          video.autoplay = false;
          video.removeAttribute('autoplay');
        }
      });
    }

    open(event, index, id) {
      const drawer = document.querySelector(`shoppable-drawer.shoppable-drawer--${id}`);
      if (drawer) drawer.openWithIndex(event, index);
    }
  }

  customElements.define('shoppable-layout-slider', ShoppableLayoutSlider);
}
